<div class="sections" #container>
    <div *ngFor="let section of articleModel.sections; let first=first; let last=last" class="section">
        <admin-section [componentName]="section.componentName" [(sectionData)]="section.sectionData">
        </admin-section>
        <div class="section-controls">
            <i class="pi pi-arrow-up" (click)="updateSectionOrder(section, -1)" *ngIf="!first"></i>
            <i class="pi pi-arrow-down" (click)="updateSectionOrder(section, 1)" *ngIf="!last"></i>
            <i class="pi pi-trash" (click)="deleteSection(section)"></i>
            <i class="pi pi-plus" (click)="openSectionModal(section.order + 1)"></i>
        </div>
    </div>
    <div class="new-section">
        <i class="pi pi-plus" (click)="openSectionModal()"></i>
    </div>
    <p-confirmDialog [appendTo]="container"></p-confirmDialog>
</div>

<p-dialog header="Ajouter une section" [(visible)]="showAddSectionModal" [style]="{width: '60vw'}">
    <admin-add-section (createSection)="addSection($event)"></admin-add-section>
</p-dialog>